import { cn } from '../../../../utils';
import { ContentDescription } from '../shared/content-description';
import type { ContentDisplayVariant } from '../../hooks/content-renderer-types';
import type { StudentImageContent } from '../../hooks/use-class-blocks';
import { renderInlineMarkdown } from '../../../custom/markdown';
import { ZoomableImage } from '../../../custom/zoomable-image';

interface ImageContentDisplayProps {
  content: StudentImageContent;
  variant?: ContentDisplayVariant;
}

export function ImageContentDisplay({ content, variant = 'card' }: ImageContentDisplayProps) {
  if (!content.url) {
    return null;
  }

  return (
    <div className={cn('flex justify-center', variant === 'inline' && 'justify-start')}>
      <figure className="space-y-2 w-full mx-auto max-w-[90vw] md:max-w-[40vw]">
        <ZoomableImage
          src={content.url}
          alt={content.title ?? 'Class image'}
          className="mx-auto w-full max-h-[50vh] rounded-lg border border-border object-contain shadow-sm"
        />
        {(content.title || content.description) && (
          <figcaption className="w-full space-y-1 text-center [overflow-wrap:anywhere]">
            {content.title && (
              <span className="text-sm font-medium text-muted-foreground">
                {renderInlineMarkdown(content.title, 'image-content-title')}
              </span>
            )}
            <ContentDescription
              as="p"
              text={content.description}
              markdown
              className="m-0 text-center"
            />
          </figcaption>
        )}
      </figure>
    </div>
  );
}
